import { createNamespace } from '../utils';
import Button from '../button';

var _createNamespace = createNamespace('nodata'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    figure: {
      type: [Number, String],
      default: 1
    },
    title: String,
    tip: String,
    button: String
  },
  methods: {
    genFigure: function genFigure() {
      if (typeof this.figure === 'number') {
        switch (this.figure) {
          case 1:
            return 'http://mui.ucmed.cn/images/nodata/nofind.png';

          case 2:
            return 'http://mui.ucmed.cn/images/nodata/noevalution.png';

          case 3:
            return 'http://mui.ucmed.cn/images/nodata/noreport.png';

          case 4:
            return 'http://mui.ucmed.cn/images/nodata/nopayment.png';

          case 5:
            return 'http://mui.ucmed.cn/images/nodata/nocall.png';

          case 6:
            return 'http://mui.ucmed.cn/images/nodata/norecord.png';

          case 7:
            return 'http://mui.ucmed.cn/images/nodata/nocollection.png';

          case 8:
            return 'http://mui.ucmed.cn/images/nodata/nonews.png';

          case 9:
            return 'http://mui.ucmed.cn/images/nodata/nopatient.png';

          case 10:
            return 'http://mui.ucmed.cn/images/nodata/nodoctor.png';

          case 11:
            return 'http://mui.ucmed.cn/images/nodata/paysuccess.png';

          case 12:
            return 'http://mui.ucmed.cn/images/nodata/payfail.png';

          case 13:
            return 'http://mui.ucmed.cn/images/nodata/nolive.png';

          case 14:
            return 'http://mui.ucmed.cn/images/nodata/nodata.png';

          case 15:
            return 'http://mui.ucmed.cn/images/nodata/nodepartment.png';

          case 16:
            return 'http://mui.ucmed.cn/images/nodata/nointernet.png';

          case 17:
            return 'http://mui.ucmed.cn/images/nodata/noauthority.png';

          case 18:
            return 'http://mui.ucmed.cn/images/nodata/health.png';

          case 19:
            return 'http://mui.ucmed.cn/images/nodata/finish.png';

          case 20:
            return 'http://mui.ucmed.cn/images/nodata/nocheckup.png';

          case 21:
            return 'http://mui.ucmed.cn/images/nodata/system.png';

          case 22:
            return 'http://mui.ucmed.cn/images/nodata/nofloor.png';

          case 23:
            return 'http://mui.ucmed.cn/images/nodata/noanydata.png';
        }
      } else {
        return this.figure;
      }
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var slots = this.slots,
        figure = this.figure,
        title = this.title,
        tip = this.tip,
        button = this.button;
    return h("div", {
      "class": bem()
    }, [slots('figure') || figure && h("img", {
      "class": bem('figure'),
      "attrs": {
        "src": this.genFigure()
      }
    }), title && h("p", {
      "class": bem('title')
    }, [" ", title, " "]), tip && h("p", {
      "class": bem('tip')
    }, [" ", tip, " "]), button && h(Button, {
      "attrs": {
        "type": "primary",
        "size": "small"
      },
      "class": bem('button'),
      "on": {
        "click": function click() {
          _this.$emit('clickButton');
        }
      }
    }, [button]), slots('default')]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/nodata/index.js
// module id = null
// module chunks = 